import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '../../../types/command';
import {
  HeroSection,
  HeroPrompt,
  HeroTitle,
  HeroDescription,
  BlinkingCursor,
} from '../styles';

interface HeroProps {
  themeName: ThemeType;
}

const Hero: React.FC<HeroProps> = ({ themeName }) => {
  const { t } = useTranslation();
  const [showTitle, setShowTitle] = useState(false);
  const [showDesc, setShowDesc] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setShowTitle(true), 300);
    const t2 = setTimeout(() => setShowDesc(true), 700);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, []);

  const prompt = themeName === 'ubuntu'
    ? '$ cat services.md'
    : themeName === 'powershell'
    ? 'PS> Get-Services'
    : 'C:\\> dir services';

  return (
    <HeroSection $themeName={themeName}>
      <HeroPrompt $themeName={themeName}>
        {prompt}
        <BlinkingCursor $themeName={themeName} />
      </HeroPrompt>
      <HeroTitle
        $themeName={themeName}
        style={{
          opacity: showTitle ? 1 : 0,
          transform: showTitle ? 'translateY(0)' : 'translateY(10px)',
          transition: 'all 0.5s ease',
        }}
      >
        {t('services.title')}
      </HeroTitle>
      <HeroDescription
        $themeName={themeName}
        style={{
          opacity: showDesc ? 1 : 0,
          transform: showDesc ? 'translateY(0)' : 'translateY(10px)',
          transition: 'all 0.5s ease',
        }}
      >
        {t('services.description')}
      </HeroDescription>
    </HeroSection>
  );
};

export default Hero;
